/**
 * Helpers for when to treat manual shift times as "app time" (omit from payload to avoid approval).
 */

const ONE_MINUTE_MS = 60_000;

/**
 * Returns true if the given ISO 8601 datetime is within 1 minute of the current time.
 * Used to avoid sending manual_arrival_time / manual_end_time when the user's selection
 * is effectively the same as the request time (reduces unnecessary manager approvals).
 * Comparison is in UTC instant space, so timezone-safe.
 */
export function isWithinOneMinuteOfNow(isoString: string): boolean {
  if (!isoString || typeof isoString !== "string") return false;
  const parsed = new Date(isoString);
  if (Number.isNaN(parsed.getTime())) return false;
  const diffMs = Math.abs(parsed.getTime() - Date.now());
  return diffMs <= ONE_MINUTE_MS;
}
